<template>
  <div class="statistics">
    <div class="title">经济效益</div>
    <div class="case row-center">
      <div class="item">
        <div class="name">当前时段方案</div>
        <div class="num">储能充放电</div>
      </div>
      <div class="item">
        <div class="name">充电时段</div>
        <div class="num">00:00-04:00</div>
      </div>
      <div class="item">
        <div class="name">放电时段</div>
        <div class="num">20:00-22:00</div>
      </div>
    </div>
    <div class="cont row-center">
        <div class="item">
            <div class="name">本日节约成本</div>
            <div class="num">88.94<span>￥</span></div>
        </div>
        <div class="item">
            <div class="name">本月节约成本</div>
            <div class="num">{{(88.94*new Date().getDate()).toFixed(2)}}<span>￥</span></div>
        </div>
        <div class="item">
            <div class="name">本年节约成本</div>
            <div class="num">{{(88.94*47).toFixed(2)}}<span>￥</span></div>
        </div>
        <div class="item">
            <div class="name">累计节约成本</div>
            <div class="num">{{(88.94*47).toFixed(2)}}<span>￥</span></div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.statistics{
    height: 29.62962963vh !important;
    padding:15rem 23rem;
    .title{
        font-size: 18rem;
        font-weight: bold;
        margin-bottom: 10rem;
    }
    .name{
        text-align: center;
        font-size: 18rem;
    }
    .cont{
        justify-content: space-between;
        .item{
            background: rgba(0, 43, 102, 0.03);
            width: 49.2%;
            height: 7.5vh;
            text-align: left;
            margin-bottom: 8rem;
            padding-left: 24px;
            border-radius: 6rem;
            .name{
                font-size: 16rem;
                margin-top: 1.2vh;
                text-align: left;
            }
            .num{
                font-size: 26rem;
                font-weight: bold;
                color: #0D94FF;
            }
            span{
                font-size: 20rem;
                margin-left: 3rem
            }
        }
    }
}
.case{
    justify-content: space-between;
    .item{
        background: rgba(0, 43, 102, 0.03);
        width: 32.5%;
        height: 7vh;
        text-align: left;
        margin-bottom: 8rem;
        padding-left: 24px;
        border-radius: 6rem;
        .name{
            font-size: 16rem;
            margin-top: 1.2vh;
            text-align: left;
        }
        .num{
            font-size: 22rem;
            font-weight: bold;
            color: #0D94FF;
        }
        span{
            font-size: 20rem;
            margin-left: 3rem
        }
    }
}
</style>